import { makeDropdown } from "../utils";

const appConfig = JSON.parse(import.meta.env.VITE_APP_CONFIG);

export const back = {
    "label": "Close",
    "class": "text-red font-medium",
    "break": true,
    action(contextData) {
        contextData.router.back();
    }
};



export default {
    back
}
